import { create } from 'zustand';

/**
 * Whether Unity's copy board currently holds a shot.
 *
 * Ambient state, not an ack: the copy board is a global singleton on the Unity side
 * (DocumentCopyPasteManager) shared with the canvas's own copy/paste menu, and Unity resets it on
 * project open and on custom-asset churn. So the web cannot derive it from "the user pressed Copy
 * here" — it has to be told. Unity pushes `copyBoardState` after a board copy, on project load, on
 * genuine canvas return, and on the copy board's own change events.
 *
 * The board's shot context menu gates its Insert and Paste rows on this.
 */
interface CopyBoardState {
  hasShot: boolean;
  setHasShot: (hasShot: boolean) => void;
}

export const useCopyBoardStore = create<CopyBoardState>((set) => ({
  hasShot: false,
  setHasShot: (hasShot) => set({ hasShot }),
}));
